// Exports
export default {
	"label": "label_RXPi4",
	"row": "row_hFyM4",
	"endSlot": "endSlot_8R30E"
};
